import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateParkingDataState,
	globalStateParkingDataReducer,
	globalStateParkingDataAction,
} from "./data";

export type StateParking = {
	data: globalStateParkingDataState;
};

export const parking = combineReducers<StateParking>({
	data: globalStateParkingDataReducer,
});

export const globalStateParkingAction = {
	data: globalStateParkingDataAction,
};

export default parking;
